import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"
// import WebViewer from '@pdftron/webviewer'

// Material-UI Core
import {makeStyles, withStyles} from '@material-ui/core/styles'
// import Typography from '@material-ui/core/Typography'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
// import ArrowRightIcon from '@material-ui/icons/ArrowRight'
// import ChevronRightIcon from '@material-ui/icons/ChevronRight'

// Custom Component
import useLoading from "../Loading/useLoading"
import DrawingHistoryTable from "./DrawingHistoryTable"

// Custom Style
// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, blackColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import drawingHistoryStyle from '../../styles/jss/components/drawingRegister/drawingHistoryStyle'

// Global Function
// import {webViewerLoadDocument} from "../../global/webViewerLoadDocument"

// Fetch Data
// import {getRelatedItems} from '../../dataSource/drawingRegister'


const useStyles = makeStyles(theme => drawingHistoryStyle(theme))

const DrawingHistory = props => {
	const {drawingDetailRecord} = props
	const store = require('store')
	const classes = useStyles()
	

	useEffect(() => {
	
	}, [])


	return (
		// console.log("Drawing Detail Record | Variable: drawingDetailRecord (DrawingHistory.js)"),
		// console.log(drawingDetailRecord),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div  className={classes.drawingTable}>
				<DrawingHistoryTable
					historyRecord={drawingDetailRecord.dwg_actions}
				/>
			</div>
		</Fragment>
	)
}


export default DrawingHistory